<template>
  <div class="flex flex-col items-center justify-center">
    <div class="flex w-full flex-col items-center justify-center bg-theme-2b py-8 md:py-16">
      <h2 class="text-center text-xl font-medium">{{ $t("pages.profile-shop.no_results.title") }}</h2>

      <p class="mt-1 text-center">
        {{ $t("pages.profile-shop.no_results.desc_1") }}
      </p>

      <p class="mt-3 text-center">
        <span>{{ `${$t("pages.profile-shop.no_results.desc_2.part1")} ` }}</span>

        <IAILink :url="SUGGEST_A_STYLE_URL" :text="$t('pages.profile-shop.no_results.desc_2.part2')" />

        <span>{{ ` ${$t("pages.profile-shop.no_results.desc_2.part3")}` }}</span>
      </p>

      <IAIButton
        class="mt-5"
        :label="$t('pages.profile-shop.no_results.clear_filters')"
        variant="outline"
        @click="$emit('reset')"
      />
    </div>

    <template v-if="recommendationsData?.profiles.length">
      <h2 class="mb-3 mt-10 self-start font-medium md:text-lg">
        {{ $t("pages.profile-shop.no_results.suggestions_title") }}
      </h2>

      <ProfileGrid
        :profiles="recommendationsProfiles"
        :is-loading="isRecommendationsLoading"
        :skeleton-count="6"
        selected-compare-style-image="original"
        source="empty_state"
        :scrollable="mobile_or_desktop === 'desktop'"
      />
    </template>
  </div>
</template>

<script lang="ts" setup>
import { IAIButton, IAILink } from "@/core-ui-vue";
import { SUGGEST_A_STYLE_URL } from "@/features/profile-shop/utils";
import { useQuery } from "@tanstack/vue-query";
import { profileRecommendationsQueryOptions } from "@/features/profile-shop/services/api";
import { computed } from "vue";
import { useProfileShopFilters } from "@/features/profile-shop/composables/useProfileShopFilters";
import ProfileGrid from "@/features/profile-shop/components/profileGrid/ProfileGrid.vue";
import { universalStorage } from "@/utils/universal-storage";

defineEmits<{
  (e: "reset"): void;
}>();

const mobile_or_desktop = universalStorage.get("mobile_or_desktop");

const filters = useProfileShopFilters();

if (!filters) {
  throw new Error("useProfileShopFilters must be used within a ProfileShopFilters provider");
}

const recommendationsQuery = computed(() => ({
  type: "filters" as const,
  filters: filters.activeFilters.value,
}));

const { data: recommendationsData, isLoading: isRecommendationsLoading } = useQuery(
  profileRecommendationsQueryOptions(recommendationsQuery)
);

const recommendationsProfiles = computed(() => {
  return mobile_or_desktop === "desktop"
    ? recommendationsData.value?.profiles
    : recommendationsData.value?.profiles?.slice(0, 3);
});
</script>
